import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import EmailEnvioSearchForm from './search-form.js'

const EmailEnvioSearchModel = {
  emailFrom: null
}

export default {
  mixins: [ActionsForm],
  name: 'EmailEnvioModeloSearch',
  data () {
    return {
      data: EmailEnvioSearchModel,
      form: EmailEnvioSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.form.emailFrom.value = null
      this.parentComponent.filters = null
      this.parentComponent.onLoad()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/email/components/search/search.js